import styles from './loaderAnimation.module.css'


export const LoaderAnimation = () => {

    return <div className={styles.loaderAnimation}>
        <div></div><div></div><div></div><div></div>
    </div>
}
